/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class AuditLogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getPaged(filter: AuditLogFilterDto, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<AuditLogPagedResponse>> {
        let url_ = this.baseUrl + "/AuditLog?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: Response): Promise<SwaggerResponse<AuditLogPagedResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditLogPagedResponse.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AuditLogPagedResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class CompressorClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getIgnitionOrden(id: string | null, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<IntermittentIgnitionDto>> {
        let url_ = this.baseUrl + "/compressor/{id}/ignitionOrden?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIgnitionOrden(_response);
        });
    }

    protected processGetIgnitionOrden(response: Response): Promise<SwaggerResponse<IntermittentIgnitionDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntermittentIgnitionDto.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<IntermittentIgnitionDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateIgnitionOrden(id: string | null, dto: IntermittentIgnitionDto, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/compressor/{id}/ignitionOrden?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateIgnitionOrden(_response);
        });
    }

    protected processUpdateIgnitionOrden(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class GatewaysClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getGateway(siteId?: string | null | undefined, ids?: string[] | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<GatewayWithBatteryResponse[]>> {
        let url_ = this.baseUrl + "/gateways?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGateway(_response);
        });
    }

    protected processGetGateway(response: Response): Promise<SwaggerResponse<GatewayWithBatteryResponse[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GatewayWithBatteryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<GatewayWithBatteryResponse[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getGateways(tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<GatewayResponse[]>> {
        let url_ = this.baseUrl + "/gateways/GetAll?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGateways(_response);
        });
    }

    protected processGetGateways(response: Response): Promise<SwaggerResponse<GatewayResponse[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GatewayResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<GatewayResponse[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    exportGateways(tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/gateways/Export?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "text/csv"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportGateways(_response);
        });
    }

    protected processExportGateways(response: Response): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class PlungersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: string | null, api_version?: string | null | undefined): Promise<SwaggerResponse<Plunger>> {
        let url_ = this.baseUrl + "/plungers/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SwaggerResponse<Plunger>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Plunger.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Plunger>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getArrivalTimes(id: string | null, api_version?: string | null | undefined): Promise<SwaggerResponse<PlungerArrivalTimesResponse>> {
        let url_ = this.baseUrl + "/plungers/{id}/arrival-times?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArrivalTimes(_response);
        });
    }

    protected processGetArrivalTimes(response: Response): Promise<SwaggerResponse<PlungerArrivalTimesResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlungerArrivalTimesResponse.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PlungerArrivalTimesResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getSettings(id: string | null, api_version?: string | null | undefined): Promise<SwaggerResponse<PlungerDescriptionResponse>> {
        let url_ = this.baseUrl + "/plungers/{id}/settings?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: Response): Promise<SwaggerResponse<PlungerDescriptionResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlungerDescriptionResponse.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PlungerDescriptionResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateAutoAdjustModeSettings(id: string | null, rawSettings: PlungerAutoAdjustModeSettingsApiModel, api_version?: string | null | undefined): Promise<SwaggerResponse<PlungerJob>> {
        let url_ = this.baseUrl + "/plungers/{id}/settings/auto-adjust-mode?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rawSettings);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAutoAdjustModeSettings(_response);
        });
    }

    protected processUpdateAutoAdjustModeSettings(response: Response): Promise<SwaggerResponse<PlungerJob>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlungerJob.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PlungerJob>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateCommonWellSettings(id: string | null, rawSettings: PlungerCommonWellSettingsApiModel, api_version?: string | null | undefined): Promise<SwaggerResponse<PlungerJob>> {
        let url_ = this.baseUrl + "/plungers/{id}/settings/well?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rawSettings);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCommonWellSettings(_response);
        });
    }

    protected processUpdateCommonWellSettings(response: Response): Promise<SwaggerResponse<PlungerJob>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlungerJob.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PlungerJob>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updatePressureModeSettings(id: string | null, rawSettings: PlungerPressureModeSettingsApiModel, api_version?: string | null | undefined): Promise<SwaggerResponse<PlungerJob>> {
        let url_ = this.baseUrl + "/plungers/{id}/settings/pressure-mode?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rawSettings);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePressureModeSettings(_response);
        });
    }

    protected processUpdatePressureModeSettings(response: Response): Promise<SwaggerResponse<PlungerJob>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlungerJob.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PlungerJob>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateTimeModeSettings(id: string | null, rawSettings: PlungerTimeModeSettingsApiModel, api_version?: string | null | undefined): Promise<SwaggerResponse<PlungerJob>> {
        let url_ = this.baseUrl + "/plungers/{id}/settings/time-mode?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rawSettings);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTimeModeSettings(_response);
        });
    }

    protected processUpdateTimeModeSettings(response: Response): Promise<SwaggerResponse<PlungerJob>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlungerJob.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PlungerJob>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getJobDetails(jobId: string | null, api_version?: string | null | undefined): Promise<SwaggerResponse<PlungerJob>> {
        let url_ = this.baseUrl + "/plungers/jobs/{jobId}?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobDetails(_response);
        });
    }

    protected processGetJobDetails(response: Response): Promise<SwaggerResponse<PlungerJob>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlungerJob.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PlungerJob>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getJobList(id: string | null, api_version?: string | null | undefined): Promise<SwaggerResponse<PlungerJobInfo[]>> {
        let url_ = this.baseUrl + "/plungers/{id}/jobs?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobList(_response);
        });
    }

    protected processGetJobList(response: Response): Promise<SwaggerResponse<PlungerJobInfo[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlungerJobInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PlungerJobInfo[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateOperatingMode(id: string | null, request: UpdatePlungerOperatingModeRequest, api_version?: string | null | undefined): Promise<SwaggerResponse<PlungerJob>> {
        let url_ = this.baseUrl + "/plungers/{id}/mode?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOperatingMode(_response);
        });
    }

    protected processUpdateOperatingMode(response: Response): Promise<SwaggerResponse<PlungerJob>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlungerJob.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PlungerJob>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class ProductPanelClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSitesByQuery(request?: string | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<SitesSearchResponse[]>> {
        let url_ = this.baseUrl + "/ProductPanel/sites?";
        if (request === null)
            throw new Error("The parameter 'request' cannot be null.");
        else if (request !== undefined)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSitesByQuery(_response);
        });
    }

    protected processGetSitesByQuery(response: Response): Promise<SwaggerResponse<SitesSearchResponse[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SitesSearchResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SitesSearchResponse[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getSitesBylQuery(assetsIds?: string[] | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<SitesSearchResponse[]>> {
        let url_ = this.baseUrl + "/ProductPanel/sites/assets?";
        if (assetsIds !== undefined && assetsIds !== null)
            assetsIds && assetsIds.forEach(item => { url_ += "assetsIds=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSitesBylQuery(_response);
        });
    }

    protected processGetSitesBylQuery(response: Response): Promise<SwaggerResponse<SitesSearchResponse[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SitesSearchResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SitesSearchResponse[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getAssetsBylQuery(request?: string | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<AssetsSearchResponse[]>> {
        let url_ = this.baseUrl + "/ProductPanel/assets?";
        if (request !== undefined && request !== null)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssetsBylQuery(_response);
        });
    }

    protected processGetAssetsBylQuery(response: Response): Promise<SwaggerResponse<AssetsSearchResponse[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetsSearchResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AssetsSearchResponse[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getAssetsBylQuery2(sitesIds?: string[] | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<AssetsSearchResponse[]>> {
        let url_ = this.baseUrl + "/ProductPanel/assets/sites?";
        if (sitesIds !== undefined && sitesIds !== null)
            sitesIds && sitesIds.forEach(item => { url_ += "sitesIds=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssetsBylQuery2(_response);
        });
    }

    protected processGetAssetsBylQuery2(response: Response): Promise<SwaggerResponse<AssetsSearchResponse[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetsSearchResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AssetsSearchResponse[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    get(sitesIds?: string[] | null | undefined, assetsIds?: string[] | null | undefined, from?: Date | undefined, to?: Date | undefined, productType?: number[] | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<ProductResponse[]>> {
        let url_ = this.baseUrl + "/ProductPanel?";
        if (sitesIds !== undefined && sitesIds !== null)
            sitesIds && sitesIds.forEach(item => { url_ += "sitesIds=" + encodeURIComponent("" + item) + "&"; });
        if (assetsIds !== undefined && assetsIds !== null)
            assetsIds && assetsIds.forEach(item => { url_ += "assetsIds=" + encodeURIComponent("" + item) + "&"; });
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (productType !== undefined && productType !== null)
            productType && productType.forEach(item => { url_ += "productType=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SwaggerResponse<ProductResponse[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ProductResponse[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getExport(sitesIds?: string[] | null | undefined, assetsIds?: string[] | null | undefined, from?: Date | undefined, to?: Date | undefined, productType?: number[] | null | undefined, localDate?: Date | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/ProductPanel/export?";
        if (sitesIds !== undefined && sitesIds !== null)
            sitesIds && sitesIds.forEach(item => { url_ += "sitesIds=" + encodeURIComponent("" + item) + "&"; });
        if (assetsIds !== undefined && assetsIds !== null)
            assetsIds && assetsIds.forEach(item => { url_ += "assetsIds=" + encodeURIComponent("" + item) + "&"; });
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (productType !== undefined && productType !== null)
            productType && productType.forEach(item => { url_ += "productType=" + encodeURIComponent("" + item) + "&"; });
        if (localDate === null)
            throw new Error("The parameter 'localDate' cannot be null.");
        else if (localDate !== undefined)
            url_ += "localDate=" + encodeURIComponent(localDate ? "" + localDate.toJSON() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "text/csv"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExport(_response);
        });
    }

    protected processGetExport(response: Response): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getProducts(api_version?: string | null | undefined): Promise<SwaggerResponse<ProductTypeModel[]>> {
        let url_ = this.baseUrl + "/ProductPanel/products?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProducts(_response);
        });
    }

    protected processGetProducts(response: Response): Promise<SwaggerResponse<ProductTypeModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ProductTypeModel[]>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class PumpClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(siteId?: string | null | undefined, assetId?: string | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<PumpResponse[]>> {
        let url_ = this.baseUrl + "/pump?";
        if (siteId !== undefined && siteId !== null)
            url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
        if (assetId !== undefined && assetId !== null)
            url_ += "AssetId=" + encodeURIComponent("" + assetId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SwaggerResponse<PumpResponse[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PumpResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PumpResponse[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    provisionPump(request: ProvisionPumpRequest, tenantId?: number | undefined, userEmail?: string | null | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/pump/pump?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userEmail": userEmail !== undefined && userEmail !== null ? "" + userEmail : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProvisionPump(_response);
        });
    }

    protected processProvisionPump(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    editPump(request: ProvisionPumpRequest, id: string | null, tenantId?: number | undefined, userEmail?: string | null | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/pump/pump/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userEmail": userEmail !== undefined && userEmail !== null ? "" + userEmail : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditPump(_response);
        });
    }

    protected processEditPump(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getPumps(tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<PumpResponse>> {
        let url_ = this.baseUrl + "/pump/AllPumps?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPumps(_response);
        });
    }

    protected processGetPumps(response: Response): Promise<SwaggerResponse<PumpResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PumpResponse.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PumpResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getPumpsBySite(siteId: string | null, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<PumpResponse[]>> {
        let url_ = this.baseUrl + "/pump/PumpsBySite/{siteId}?";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPumpsBySite(_response);
        });
    }

    protected processGetPumpsBySite(response: Response): Promise<SwaggerResponse<PumpResponse[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PumpResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PumpResponse[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    createPumpTelemetry(pumpTelemetry: PumpTelemetryModel, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<FileResponse | null>> {
        let url_ = this.baseUrl + "/pump/Telemetry?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pumpTelemetry);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePumpTelemetry(_response);
        });
    }

    protected processCreatePumpTelemetry(response: Response): Promise<SwaggerResponse<FileResponse | null>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse | null>>(new SwaggerResponse(status, _headers, <any>null));
    }

    createPumpLog(pumpLog: PumpLogRequest, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<FileResponse | null>> {
        let url_ = this.baseUrl + "/pump/Log?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pumpLog);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePumpLog(_response);
        });
    }

    protected processCreatePumpLog(response: Response): Promise<SwaggerResponse<FileResponse | null>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse | null>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getLastLog(pumpDeviceId: string | null, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<PumpLogServiceResponse>> {
        let url_ = this.baseUrl + "/pump/Log/{pumpDeviceId}?";
        if (pumpDeviceId === undefined || pumpDeviceId === null)
            throw new Error("The parameter 'pumpDeviceId' must be defined.");
        url_ = url_.replace("{pumpDeviceId}", encodeURIComponent("" + pumpDeviceId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLastLog(_response);
        });
    }

    protected processGetLastLog(response: Response): Promise<SwaggerResponse<PumpLogServiceResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PumpLogServiceResponse.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PumpLogServiceResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getLastLogs(pumpDeviceId: string | null, page?: number | undefined, pageSize?: number | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<PagedResultOfPumpLogsWebResponse>> {
        let url_ = this.baseUrl + "/pump/Logs/{pumpDeviceId}?";
        if (pumpDeviceId === undefined || pumpDeviceId === null)
            throw new Error("The parameter 'pumpDeviceId' must be defined.");
        url_ = url_.replace("{pumpDeviceId}", encodeURIComponent("" + pumpDeviceId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLastLogs(_response);
        });
    }

    protected processGetLastLogs(response: Response): Promise<SwaggerResponse<PagedResultOfPumpLogsWebResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfPumpLogsWebResponse.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PagedResultOfPumpLogsWebResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class SensorsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSensors(siteId?: string | null | undefined, ids?: string[] | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<SensorWithBatteryResponse[]>> {
        let url_ = this.baseUrl + "/sensors?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSensors(_response);
        });
    }

    protected processGetSensors(response: Response): Promise<SwaggerResponse<SensorWithBatteryResponse[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SensorWithBatteryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SensorWithBatteryResponse[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateMany(sensorModels: WriteSensorApiModel[], tenantId?: number | undefined, userEmail?: string | null | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/sensors?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sensorModels);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userEmail": userEmail !== undefined && userEmail !== null ? "" + userEmail : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMany(_response);
        });
    }

    protected processUpdateMany(response: Response): Promise<SwaggerResponse<string[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getSensorsPaged(siteId?: string | null | undefined, sensorId?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<PagedResultOfSensorResponse>> {
        let url_ = this.baseUrl + "/sensors/paged?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (sensorId !== undefined && sensorId !== null)
            url_ += "sensorId=" + encodeURIComponent("" + sensorId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSensorsPaged(_response);
        });
    }

    protected processGetSensorsPaged(response: Response): Promise<SwaggerResponse<PagedResultOfSensorResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfSensorResponse.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PagedResultOfSensorResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getAllSensors(tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<SensorResponse[]>> {
        let url_ = this.baseUrl + "/sensors/AllSensors?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSensors(_response);
        });
    }

    protected processGetAllSensors(response: Response): Promise<SwaggerResponse<SensorResponse[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SensorResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SensorResponse[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    get(id: string | null, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<SensorResponse>> {
        let url_ = this.baseUrl + "/sensors/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SwaggerResponse<SensorResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SensorResponse.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SensorResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    delete(id: string | null, statusId?: number | undefined, comment?: string | null | undefined, replacementSensorId?: string | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/sensors/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        if (replacementSensorId !== undefined && replacementSensorId !== null)
            url_ += "replacementSensorId=" + encodeURIComponent("" + replacementSensorId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getSitesWithSensorsReportExport(tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/sensors/SitesWithSensorsExport?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "text/csv"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSitesWithSensorsReportExport(_response);
        });
    }

    protected processGetSitesWithSensorsReportExport(response: Response): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getSensorModels(api_version?: string | null | undefined): Promise<SwaggerResponse<SensorModelApiModel[]>> {
        let url_ = this.baseUrl + "/sensors/models?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSensorModels(_response);
        });
    }

    protected processGetSensorModels(response: Response): Promise<SwaggerResponse<SensorModelApiModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SensorModelApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SensorModelApiModel[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getSensorUseCases(api_version?: string | null | undefined): Promise<SwaggerResponse<SensorUseCasesResponse[]>> {
        let url_ = this.baseUrl + "/sensors/useCases?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSensorUseCases(_response);
        });
    }

    protected processGetSensorUseCases(response: Response): Promise<SwaggerResponse<SensorUseCasesResponse[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SensorUseCasesResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SensorUseCasesResponse[]>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class SiteClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getByUserId(userId?: string | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<SiteApiModel[]>> {
        let url_ = this.baseUrl + "/site/byUser?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByUserId(_response);
        });
    }

    protected processGetByUserId(response: Response): Promise<SwaggerResponse<SiteApiModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SiteApiModel[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getAll(hasCompressorDevice?: boolean | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<SiteApiModel[]>> {
        let url_ = this.baseUrl + "/site?";
        if (hasCompressorDevice !== undefined && hasCompressorDevice !== null)
            url_ += "HasCompressorDevice=" + encodeURIComponent("" + hasCompressorDevice) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<SwaggerResponse<SiteApiModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SiteApiModel[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    addSite(siteRequestApiModel: SiteApiModel, tenantId?: number | undefined, userEmail?: string | null | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<EntityIdViewModel>> {
        let url_ = this.baseUrl + "/site?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(siteRequestApiModel);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userEmail": userEmail !== undefined && userEmail !== null ? "" + userEmail : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddSite(_response);
        });
    }

    protected processAddSite(response: Response): Promise<SwaggerResponse<EntityIdViewModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityIdViewModel.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<EntityIdViewModel>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateSite(siteRequestApiModel: SiteApiModel, tenantId?: number | undefined, userEmail?: string | null | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<EntityIdViewModel>> {
        let url_ = this.baseUrl + "/site?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(siteRequestApiModel);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userEmail": userEmail !== undefined && userEmail !== null ? "" + userEmail : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSite(_response);
        });
    }

    protected processUpdateSite(response: Response): Promise<SwaggerResponse<EntityIdViewModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityIdViewModel.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<EntityIdViewModel>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getByQuery(query?: string | null | undefined, resultSize?: number | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<SiteApiModel[]>> {
        let url_ = this.baseUrl + "/site/search?";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (resultSize === null)
            throw new Error("The parameter 'resultSize' cannot be null.");
        else if (resultSize !== undefined)
            url_ += "ResultSize=" + encodeURIComponent("" + resultSize) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByQuery(_response);
        });
    }

    protected processGetByQuery(response: Response): Promise<SwaggerResponse<SiteApiModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SiteApiModel[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getByIds(siteIds?: string[] | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<SiteApiModel[]>> {
        let url_ = this.baseUrl + "/site/byIds?";
        if (siteIds !== undefined && siteIds !== null)
            siteIds && siteIds.forEach(item => { url_ += "siteIds=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByIds(_response);
        });
    }

    protected processGetByIds(response: Response): Promise<SwaggerResponse<SiteApiModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SiteApiModel[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    drillDown(exactQuery?: boolean | undefined, state?: string | null | undefined, county?: string | null | undefined, township?: string | null | undefined, region?: string | null | undefined, field?: string | null | undefined, owner?: string | null | undefined, ownerType?: string | null | undefined, drillDownClusterType?: string | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<SiteApiModel[]>> {
        let url_ = this.baseUrl + "/site/drilldown?";
        if (exactQuery === null)
            throw new Error("The parameter 'exactQuery' cannot be null.");
        else if (exactQuery !== undefined)
            url_ += "exactQuery=" + encodeURIComponent("" + exactQuery) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (county !== undefined && county !== null)
            url_ += "county=" + encodeURIComponent("" + county) + "&";
        if (township !== undefined && township !== null)
            url_ += "township=" + encodeURIComponent("" + township) + "&";
        if (region !== undefined && region !== null)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        if (field !== undefined && field !== null)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        if (owner !== undefined && owner !== null)
            url_ += "owner=" + encodeURIComponent("" + owner) + "&";
        if (ownerType !== undefined && ownerType !== null)
            url_ += "ownerType=" + encodeURIComponent("" + ownerType) + "&";
        if (drillDownClusterType !== undefined && drillDownClusterType !== null)
            url_ += "drillDownClusterType=" + encodeURIComponent("" + drillDownClusterType) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDrillDown(_response);
        });
    }

    protected processDrillDown(response: Response): Promise<SwaggerResponse<SiteApiModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SiteApiModel[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    drillDownClusters(state?: string | null | undefined, county?: string | null | undefined, region?: string | null | undefined, field?: string | null | undefined, owner?: string | null | undefined, ownerType?: string | null | undefined, drillDownClusterType?: string | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<{ [key: string]: DrillDownCluster; }>> {
        let url_ = this.baseUrl + "/site/drilldown/clusters?";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (county !== undefined && county !== null)
            url_ += "county=" + encodeURIComponent("" + county) + "&";
        if (region !== undefined && region !== null)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        if (field !== undefined && field !== null)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        if (owner !== undefined && owner !== null)
            url_ += "owner=" + encodeURIComponent("" + owner) + "&";
        if (ownerType !== undefined && ownerType !== null)
            url_ += "ownerType=" + encodeURIComponent("" + ownerType) + "&";
        if (drillDownClusterType !== undefined && drillDownClusterType !== null)
            url_ += "drillDownClusterType=" + encodeURIComponent("" + drillDownClusterType) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDrillDownClusters(_response);
        });
    }

    protected processDrillDownClusters(response: Response): Promise<SwaggerResponse<{ [key: string]: DrillDownCluster; }>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? DrillDownCluster.fromJS(resultData200[key]) : new DrillDownCluster();
                }
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<{ [key: string]: DrillDownCluster; }>>(new SwaggerResponse(status, _headers, <any>null));
    }

    get(id: string | null, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<SiteApiModel>> {
        let url_ = this.baseUrl + "/site/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SwaggerResponse<SiteApiModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SiteApiModel.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SiteApiModel>>(new SwaggerResponse(status, _headers, <any>null));
    }

    deleteSite(id: string | null, tenantId?: number | undefined, userEmail?: string | null | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<EntityIdViewModel>> {
        let url_ = this.baseUrl + "/site/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userEmail": userEmail !== undefined && userEmail !== null ? "" + userEmail : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSite(_response);
        });
    }

    protected processDeleteSite(response: Response): Promise<SwaggerResponse<EntityIdViewModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityIdViewModel.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<EntityIdViewModel>>(new SwaggerResponse(status, _headers, <any>null));
    }

    addSites(request: SiteApiModel[], tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<EntityIdViewModel[]>> {
        let url_ = this.baseUrl + "/site/many?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddSites(_response);
        });
    }

    protected processAddSites(response: Response): Promise<SwaggerResponse<EntityIdViewModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(EntityIdViewModel.fromJS(item));
            }
            else {
                result201 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result201);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = AddSitesResponse.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<EntityIdViewModel[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateCache(tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/site/cache/refresh?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCache(_response);
        });
    }

    protected processUpdateCache(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getAllSiteId(tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/site/getAll?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSiteId(_response);
        });
    }

    protected processGetAllSiteId(response: Response): Promise<SwaggerResponse<string[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getAllAssetsBySiteId(id: string | null, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/site/{id}/getAllAssets?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAssetsBySiteId(_response);
        });
    }

    protected processGetAllAssetsBySiteId(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    addSiteOwner(siteOwnerRequestApiModel: SiteOwnerApiModel, tenantId?: number | undefined, userEmail?: string | null | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<EntityIdViewModel>> {
        let url_ = this.baseUrl + "/site/Owners?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(siteOwnerRequestApiModel);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userEmail": userEmail !== undefined && userEmail !== null ? "" + userEmail : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddSiteOwner(_response);
        });
    }

    protected processAddSiteOwner(response: Response): Promise<SwaggerResponse<EntityIdViewModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityIdViewModel.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<EntityIdViewModel>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateSiteOwner(siteOwnerRequestApiModel: SiteOwnerApiModel, tenantId?: number | undefined, userEmail?: string | null | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<EntityIdViewModel>> {
        let url_ = this.baseUrl + "/site/Owners?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(siteOwnerRequestApiModel);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userEmail": userEmail !== undefined && userEmail !== null ? "" + userEmail : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSiteOwner(_response);
        });
    }

    protected processUpdateSiteOwner(response: Response): Promise<SwaggerResponse<EntityIdViewModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityIdViewModel.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<EntityIdViewModel>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getSiteOwners(id: string | null, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<SiteOwnerApiModel>> {
        let url_ = this.baseUrl + "/site/{id}/Owners?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSiteOwners(_response);
        });
    }

    protected processGetSiteOwners(response: Response): Promise<SwaggerResponse<SiteOwnerApiModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SiteOwnerApiModel.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SiteOwnerApiModel>>(new SwaggerResponse(status, _headers, <any>null));
    }

    addSiteCommment(siteCommentApiModel: SiteCommentRequestModel, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/site/Comment?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(siteCommentApiModel);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddSiteCommment(_response);
        });
    }

    protected processAddSiteCommment(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getSiteComments(siteId: string | null, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<SiteCommentResponseModel[]>> {
        let url_ = this.baseUrl + "/site/Comment/{siteId}?";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSiteComments(_response);
        });
    }

    protected processGetSiteComments(response: Response): Promise<SwaggerResponse<SiteCommentResponseModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteCommentResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SiteCommentResponseModel[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    editSiteComment(commentId: string | null, siteCommentApiModel: SiteCommentRequestModel, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/site/Comment/{commentId}?";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(siteCommentApiModel);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditSiteComment(_response);
        });
    }

    protected processEditSiteComment(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    delete(commentId: string | null, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/site/Comment/{commentId}?";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class StatisticsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getFlowAverages(siteId: string | null, fromDateTimeUtc?: Date | undefined, toDateTimeUtc?: Date | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<GetTelemetryAveragesResponse>> {
        let url_ = this.baseUrl + "/statistics/flow/{siteId}?";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (fromDateTimeUtc === null)
            throw new Error("The parameter 'fromDateTimeUtc' cannot be null.");
        else if (fromDateTimeUtc !== undefined)
            url_ += "fromDateTimeUtc=" + encodeURIComponent(fromDateTimeUtc ? "" + fromDateTimeUtc.toJSON() : "") + "&";
        if (toDateTimeUtc === null)
            throw new Error("The parameter 'toDateTimeUtc' cannot be null.");
        else if (toDateTimeUtc !== undefined)
            url_ += "toDateTimeUtc=" + encodeURIComponent(toDateTimeUtc ? "" + toDateTimeUtc.toJSON() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFlowAverages(_response);
        });
    }

    protected processGetFlowAverages(response: Response): Promise<SwaggerResponse<GetTelemetryAveragesResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTelemetryAveragesResponse.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<GetTelemetryAveragesResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    initAverageProcess(telemetryType: string | null, averageRequest: AverageProcessDtoRequest, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/statistics/telemetry/{telemetryType}/Average?";
        if (telemetryType === undefined || telemetryType === null)
            throw new Error("The parameter 'telemetryType' must be defined.");
        url_ = url_.replace("{telemetryType}", encodeURIComponent("" + telemetryType));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(averageRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInitAverageProcess(_response);
        });
    }

    protected processInitAverageProcess(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getAverageByTelemetry(telemetryType: string | null, siteId?: string | null | undefined, assetId?: string | null | undefined, fromDateTimeUtc?: Date | undefined, toDateTimeUtc?: Date | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<GetTelemetryAveragesResponse>> {
        let url_ = this.baseUrl + "/statistics/telemetry/{telemetryType}/Average?";
        if (telemetryType === undefined || telemetryType === null)
            throw new Error("The parameter 'telemetryType' must be defined.");
        url_ = url_.replace("{telemetryType}", encodeURIComponent("" + telemetryType));
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (assetId !== undefined && assetId !== null)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (fromDateTimeUtc === null)
            throw new Error("The parameter 'fromDateTimeUtc' cannot be null.");
        else if (fromDateTimeUtc !== undefined)
            url_ += "fromDateTimeUtc=" + encodeURIComponent(fromDateTimeUtc ? "" + fromDateTimeUtc.toJSON() : "") + "&";
        if (toDateTimeUtc === null)
            throw new Error("The parameter 'toDateTimeUtc' cannot be null.");
        else if (toDateTimeUtc !== undefined)
            url_ += "toDateTimeUtc=" + encodeURIComponent(toDateTimeUtc ? "" + toDateTimeUtc.toJSON() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAverageByTelemetry(_response);
        });
    }

    protected processGetAverageByTelemetry(response: Response): Promise<SwaggerResponse<GetTelemetryAveragesResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTelemetryAveragesResponse.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<GetTelemetryAveragesResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getProcessPeriodByTenant(tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<TelemetryPeriodResponse>> {
        let url_ = this.baseUrl + "/statistics/telemetry/ProcessPeriodBpd?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProcessPeriodByTenant(_response);
        });
    }

    protected processGetProcessPeriodByTenant(response: Response): Promise<SwaggerResponse<TelemetryPeriodResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TelemetryPeriodResponse.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<TelemetryPeriodResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class TelemetryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTelemetry(telemetryType: string | null, siteId?: string | null | undefined, assetId?: string | null | undefined, sensorId?: string | null | undefined, from?: Date | undefined, tenantId?: number | undefined, to?: Date | null | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<TelemetryMessageViewModel[]>> {
        let url_ = this.baseUrl + "/telemetry/{telemetryType}?";
        if (telemetryType === undefined || telemetryType === null)
            throw new Error("The parameter 'telemetryType' must be defined.");
        url_ = url_.replace("{telemetryType}", encodeURIComponent("" + telemetryType));
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (assetId !== undefined && assetId !== null)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (sensorId !== undefined && sensorId !== null)
            url_ += "sensorId=" + encodeURIComponent("" + sensorId) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTelemetry(_response);
        });
    }

    protected processGetTelemetry(response: Response): Promise<SwaggerResponse<TelemetryMessageViewModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TelemetryMessageViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<TelemetryMessageViewModel[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    exportCsv(siteId?: string | null | undefined, from?: Date | undefined, tenantId?: number | undefined, to?: Date | null | undefined, exportType?: string | null | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/telemetry/export?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (exportType !== undefined && exportType !== null)
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "text/csv"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportCsv(_response);
        });
    }

    protected processExportCsv(response: Response): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getLatestTelemetryValuesGET(telemetryType: string | null, siteId?: string | null | undefined, sensorId?: string | null | undefined, assetId?: string | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<TelemetryMessageViewModel>> {
        let url_ = this.baseUrl + "/telemetry/{telemetryType}/latest?";
        if (telemetryType === undefined || telemetryType === null)
            throw new Error("The parameter 'telemetryType' must be defined.");
        url_ = url_.replace("{telemetryType}", encodeURIComponent("" + telemetryType));
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (sensorId !== undefined && sensorId !== null)
            url_ += "sensorId=" + encodeURIComponent("" + sensorId) + "&";
        if (assetId !== undefined && assetId !== null)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatestTelemetryValuesGET(_response);
        });
    }

    protected processGetLatestTelemetryValuesGET(response: Response): Promise<SwaggerResponse<TelemetryMessageViewModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TelemetryMessageViewModel.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = TelemetryMessageViewModel.fromJS(resultData204);
            return new SwaggerResponse(status, _headers, result204);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<TelemetryMessageViewModel>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getLatestTelemetryBySites(siteIds: string[], tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<TelemetryMessageViewModel[]>> {
        let url_ = this.baseUrl + "/telemetry/latest?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(siteIds);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatestTelemetryBySites(_response);
        });
    }

    protected processGetLatestTelemetryBySites(response: Response): Promise<SwaggerResponse<TelemetryMessageViewModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TelemetryMessageViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData204)) {
                result204 = [] as any;
                for (let item of resultData204)
                    result204!.push(TelemetryMessageViewModel.fromJS(item));
            }
            else {
                result204 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result204);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<TelemetryMessageViewModel[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getTankLevelBalance(siteId?: string | null | undefined, assetId?: string | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<TankLevelBalanceResponse>> {
        let url_ = this.baseUrl + "/telemetry/TankLevelBalance?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (assetId !== undefined && assetId !== null)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTankLevelBalance(_response);
        });
    }

    protected processGetTankLevelBalance(response: Response): Promise<SwaggerResponse<TankLevelBalanceResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TankLevelBalanceResponse.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = TankLevelBalanceResponse.fromJS(resultData204);
            return new SwaggerResponse(status, _headers, result204);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<TankLevelBalanceResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getLatestTelemetryValuesPUT(telemetryType: string | null, id?: string | null | undefined, userEmail?: string | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/telemetry/{telemetryType}/Hide?";
        if (telemetryType === undefined || telemetryType === null)
            throw new Error("The parameter 'telemetryType' must be defined.");
        url_ = url_.replace("{telemetryType}", encodeURIComponent("" + telemetryType));
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (userEmail !== undefined && userEmail !== null)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatestTelemetryValuesPUT(_response);
        });
    }

    protected processGetLatestTelemetryValuesPUT(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    unhideTelemetry(telemetryType: string | null, id?: string | null | undefined, tenantId?: number | undefined, api_version?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/telemetry/{telemetryType}/Unhide?";
        if (telemetryType === undefined || telemetryType === null)
            throw new Error("The parameter 'telemetryType' must be defined.");
        url_ = url_.replace("{telemetryType}", encodeURIComponent("" + telemetryType));
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnhideTelemetry(_response);
        });
    }

    protected processUnhideTelemetry(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getTelemetryTypes(api_version?: string | null | undefined): Promise<SwaggerResponse<TelemetryTypeResponse[]>> {
        let url_ = this.baseUrl + "/telemetry/types?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTelemetryTypes(_response);
        });
    }

    protected processGetTelemetryTypes(response: Response): Promise<SwaggerResponse<TelemetryTypeResponse[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TelemetryTypeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<TelemetryTypeResponse[]>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class ProvisioningControllerVClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    provisionSensor(request: ProvisionSensorRequest, tenantId?: number | undefined, userEmail?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/v2/provisioning/sensors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userEmail": userEmail !== undefined && userEmail !== null ? "" + userEmail : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProvisionSensor(_response);
        });
    }

    protected processProvisionSensor(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    provisionSensors(request: ProvisionSensorRequest[], tenantId?: number | undefined, userEmail?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/v2/provisioning/sensors/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userEmail": userEmail !== undefined && userEmail !== null ? "" + userEmail : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProvisionSensors(_response);
        });
    }

    protected processProvisionSensors(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    provisionSensor2(request: ProvisionSensorRequestV3, tenantId?: number | undefined, userEmail?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/v3/provisioning/sensors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userEmail": userEmail !== undefined && userEmail !== null ? "" + userEmail : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProvisionSensor2(_response);
        });
    }

    protected processProvisionSensor2(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    provisionGateway(request: ProvisionGatewayRequest, tenantId?: number | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/v3/provisioning/gateways";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProvisionGateway(_response);
        });
    }

    protected processProvisionGateway(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    editGateway(request: ProvisionGatewayRequest, tenantId?: number | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/v3/provisioning/gateways";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditGateway(_response);
        });
    }

    protected processEditGateway(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    deleteGateway(gatewayId: string | null, statusId?: number | undefined, comment?: string | null | undefined, replacementSensorId?: string | null | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/v3/provisioning/gateways/{gatewayId}?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined.");
        url_ = url_.replace("{gatewayId}", encodeURIComponent("" + gatewayId));
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        if (replacementSensorId !== undefined && replacementSensorId !== null)
            url_ += "replacementSensorId=" + encodeURIComponent("" + replacementSensorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteGateway(_response);
        });
    }

    protected processDeleteGateway(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    provisionSensors2(request: ProvisionSensorRequestV3[], tenantId?: number | undefined, userEmail?: string | null | undefined): Promise<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/v3/provisioning/sensors/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userEmail": userEmail !== undefined && userEmail !== null ? "" + userEmail : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProvisionSensors2(_response);
        });
    }

    protected processProvisionSensors2(response: Response): Promise<SwaggerResponse<string[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class AuditLogPagedResponse {
    total!: number;
    page!: number;
    pageSize!: number;
    items?: AuditLogResponse[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditLogPagedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogPagedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export class AuditLogResponse {
    id?: string | undefined;
    siteId?: string | undefined;
    assetId?: string | undefined;
    entityName?: string | undefined;
    entityId?: string | undefined;
    action?: string | undefined;
    userEmail?: string | undefined;
    createdAt!: Date;
    changes?: FieldChangeResponse[] | undefined;
    entity?: { [key: string]: any; } | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            this.assetId = _data["assetId"];
            this.entityName = _data["entityName"];
            this.entityId = _data["entityId"];
            this.action = _data["action"];
            this.userEmail = _data["userEmail"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes!.push(FieldChangeResponse.fromJS(item));
            }
            if (_data["entity"]) {
                this.entity = {} as any;
                for (let key in _data["entity"]) {
                    if (_data["entity"].hasOwnProperty(key))
                        (<any>this.entity)![key] = _data["entity"][key];
                }
            }
        }
    }

    static fromJS(data: any): AuditLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        data["assetId"] = this.assetId;
        data["entityName"] = this.entityName;
        data["entityId"] = this.entityId;
        data["action"] = this.action;
        data["userEmail"] = this.userEmail;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item.toJSON());
        }
        if (this.entity) {
            data["entity"] = {};
            for (let key in this.entity) {
                if (this.entity.hasOwnProperty(key))
                    (<any>data["entity"])[key] = this.entity[key];
            }
        }
        return data; 
    }
}

export class FieldChangeResponse {
    field?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): FieldChangeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FieldChangeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data; 
    }
}

export class AuditLogFilterDto {
    query?: string | undefined;
    columnFilters?: { [key: string]: string; } | undefined;
    page!: number;
    pageSize!: number;

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            if (_data["columnFilters"]) {
                this.columnFilters = {} as any;
                for (let key in _data["columnFilters"]) {
                    if (_data["columnFilters"].hasOwnProperty(key))
                        (<any>this.columnFilters)![key] = _data["columnFilters"][key];
                }
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): AuditLogFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        if (this.columnFilters) {
            data["columnFilters"] = {};
            for (let key in this.columnFilters) {
                if (this.columnFilters.hasOwnProperty(key))
                    (<any>data["columnFilters"])[key] = this.columnFilters[key];
            }
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data; 
    }
}

export class ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export class IntermittentIgnitionDto {
    id?: string | undefined;
    compressorDeviceId?: string | undefined;
    offOrder?: IntermittentOrderDto[] | undefined;
    onOrder?: IntermittentOrderDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.compressorDeviceId = _data["compressorDeviceId"];
            if (Array.isArray(_data["offOrder"])) {
                this.offOrder = [] as any;
                for (let item of _data["offOrder"])
                    this.offOrder!.push(IntermittentOrderDto.fromJS(item));
            }
            if (Array.isArray(_data["onOrder"])) {
                this.onOrder = [] as any;
                for (let item of _data["onOrder"])
                    this.onOrder!.push(IntermittentOrderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IntermittentIgnitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermittentIgnitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["compressorDeviceId"] = this.compressorDeviceId;
        if (Array.isArray(this.offOrder)) {
            data["offOrder"] = [];
            for (let item of this.offOrder)
                data["offOrder"].push(item.toJSON());
        }
        if (Array.isArray(this.onOrder)) {
            data["onOrder"] = [];
            for (let item of this.onOrder)
                data["onOrder"].push(item.toJSON());
        }
        return data; 
    }
}

export class IntermittentOrderDto {
    wellId!: string;
    wellName!: string;
    siteId!: string;
    siteName!: string;
    order!: number;
    delay?: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
            this.wellName = _data["wellName"];
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.order = _data["order"];
            this.delay = _data["delay"];
        }
    }

    static fromJS(data: any): IntermittentOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermittentOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        data["wellName"] = this.wellName;
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["order"] = this.order;
        data["delay"] = this.delay;
        return data; 
    }
}

export class GatewayWithBatteryResponse {
    id?: string | undefined;
    siteId?: string | undefined;
    modelName?: string | undefined;
    modelDescription?: string | undefined;
    createAt!: Date;
    updateAt!: Date;
    batteryLevel?: number | undefined;
    lastReportTime?: Date | undefined;
    enableAlerts!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            this.modelName = _data["modelName"];
            this.modelDescription = _data["modelDescription"];
            this.createAt = _data["createAt"] ? new Date(_data["createAt"].toString()) : <any>undefined;
            this.updateAt = _data["updateAt"] ? new Date(_data["updateAt"].toString()) : <any>undefined;
            this.batteryLevel = _data["batteryLevel"];
            this.lastReportTime = _data["lastReportTime"] ? new Date(_data["lastReportTime"].toString()) : <any>undefined;
            this.enableAlerts = _data["enableAlerts"];
        }
    }

    static fromJS(data: any): GatewayWithBatteryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayWithBatteryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        data["modelName"] = this.modelName;
        data["modelDescription"] = this.modelDescription;
        data["createAt"] = this.createAt ? this.createAt.toISOString() : <any>undefined;
        data["updateAt"] = this.updateAt ? this.updateAt.toISOString() : <any>undefined;
        data["batteryLevel"] = this.batteryLevel;
        data["lastReportTime"] = this.lastReportTime ? this.lastReportTime.toISOString() : <any>undefined;
        data["enableAlerts"] = this.enableAlerts;
        return data; 
    }
}

export class ValidationResult {
    memberNames!: string[];
    errorMessage?: string | undefined;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["memberNames"])) {
                this.memberNames = [] as any;
                for (let item of _data["memberNames"])
                    this.memberNames!.push(item);
            }
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberNames)) {
            data["memberNames"] = [];
            for (let item of this.memberNames)
                data["memberNames"].push(item);
        }
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export class GatewayResponse {
    id?: string | undefined;
    siteId?: string | undefined;
    modelName?: string | undefined;
    modelDescription?: string | undefined;
    createAt!: Date;
    updateAt!: Date;
    enableAlerts!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            this.modelName = _data["modelName"];
            this.modelDescription = _data["modelDescription"];
            this.createAt = _data["createAt"] ? new Date(_data["createAt"].toString()) : <any>undefined;
            this.updateAt = _data["updateAt"] ? new Date(_data["updateAt"].toString()) : <any>undefined;
            this.enableAlerts = _data["enableAlerts"];
        }
    }

    static fromJS(data: any): GatewayResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        data["modelName"] = this.modelName;
        data["modelDescription"] = this.modelDescription;
        data["createAt"] = this.createAt ? this.createAt.toISOString() : <any>undefined;
        data["updateAt"] = this.updateAt ? this.updateAt.toISOString() : <any>undefined;
        data["enableAlerts"] = this.enableAlerts;
        return data; 
    }
}

export class Plunger {
    macAddr?: string | undefined;
    name?: string | undefined;
    createdDate!: number;

    init(_data?: any) {
        if (_data) {
            this.macAddr = _data["macAddr"];
            this.name = _data["name"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): Plunger {
        data = typeof data === 'object' ? data : {};
        let result = new Plunger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["macAddr"] = this.macAddr;
        data["name"] = this.name;
        data["createdDate"] = this.createdDate;
        return data; 
    }
}

export class PlungerArrivalTimesResponse {
    time!: number;
    arrivals?: number[] | undefined;
    failuresTotal!: number;
    failuresToday!: number;
    failuresAverage!: number;
    arrivalsTotal!: number;
    arrivalsAverage!: number;

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"];
            if (Array.isArray(_data["arrivals"])) {
                this.arrivals = [] as any;
                for (let item of _data["arrivals"])
                    this.arrivals!.push(item);
            }
            this.failuresTotal = _data["failuresTotal"];
            this.failuresToday = _data["failuresToday"];
            this.failuresAverage = _data["failuresAverage"];
            this.arrivalsTotal = _data["arrivalsTotal"];
            this.arrivalsAverage = _data["arrivalsAverage"];
        }
    }

    static fromJS(data: any): PlungerArrivalTimesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlungerArrivalTimesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time;
        if (Array.isArray(this.arrivals)) {
            data["arrivals"] = [];
            for (let item of this.arrivals)
                data["arrivals"].push(item);
        }
        data["failuresTotal"] = this.failuresTotal;
        data["failuresToday"] = this.failuresToday;
        data["failuresAverage"] = this.failuresAverage;
        data["arrivalsTotal"] = this.arrivalsTotal;
        data["arrivalsAverage"] = this.arrivalsAverage;
        return data; 
    }
}

export class PlungerDescriptionResponse {
    latestState?: PlungerLatestStateApiModel | undefined;
    commonWellSettings?: PlungerCommonWellSettingsApiModel | undefined;
    autoAdjustModeSettings?: PlungerAutoAdjustModeSettingsApiModel | undefined;
    pressureModeSettings?: PlungerPressureModeSettingsApiModel | undefined;
    timeModeSettings?: PlungerTimeModeSettingsApiModel | undefined;

    init(_data?: any) {
        if (_data) {
            this.latestState = _data["latestState"] ? PlungerLatestStateApiModel.fromJS(_data["latestState"]) : <any>undefined;
            this.commonWellSettings = _data["commonWellSettings"] ? PlungerCommonWellSettingsApiModel.fromJS(_data["commonWellSettings"]) : <any>undefined;
            this.autoAdjustModeSettings = _data["autoAdjustModeSettings"] ? PlungerAutoAdjustModeSettingsApiModel.fromJS(_data["autoAdjustModeSettings"]) : <any>undefined;
            this.pressureModeSettings = _data["pressureModeSettings"] ? PlungerPressureModeSettingsApiModel.fromJS(_data["pressureModeSettings"]) : <any>undefined;
            this.timeModeSettings = _data["timeModeSettings"] ? PlungerTimeModeSettingsApiModel.fromJS(_data["timeModeSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlungerDescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlungerDescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latestState"] = this.latestState ? this.latestState.toJSON() : <any>undefined;
        data["commonWellSettings"] = this.commonWellSettings ? this.commonWellSettings.toJSON() : <any>undefined;
        data["autoAdjustModeSettings"] = this.autoAdjustModeSettings ? this.autoAdjustModeSettings.toJSON() : <any>undefined;
        data["pressureModeSettings"] = this.pressureModeSettings ? this.pressureModeSettings.toJSON() : <any>undefined;
        data["timeModeSettings"] = this.timeModeSettings ? this.timeModeSettings.toJSON() : <any>undefined;
        return data; 
    }
}

export class PlungerLatestStateApiModel {
    time!: Date;
    operatingMode!: PlungerOperatingMode;
    batteryVoltage?: string | undefined;
    firmwareVersion?: string | undefined;
    casingPressure?: string | undefined;
    linePressure?: string | undefined;
    tubingPressure?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.operatingMode = _data["operatingMode"];
            this.batteryVoltage = _data["batteryVoltage"];
            this.firmwareVersion = _data["firmwareVersion"];
            this.casingPressure = _data["casingPressure"];
            this.linePressure = _data["linePressure"];
            this.tubingPressure = _data["tubingPressure"];
        }
    }

    static fromJS(data: any): PlungerLatestStateApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlungerLatestStateApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["operatingMode"] = this.operatingMode;
        data["batteryVoltage"] = this.batteryVoltage;
        data["firmwareVersion"] = this.firmwareVersion;
        data["casingPressure"] = this.casingPressure;
        data["linePressure"] = this.linePressure;
        data["tubingPressure"] = this.tubingPressure;
        return data; 
    }
}

export enum PlungerOperatingMode {
    TimeMode = 1,
    AutoAdjustMode = 2,
    PressureMode = 4,
}

export class PlungerCommonWellSettingsApiModel {
    wellDepth!: number;
    detectPlungerFalls!: boolean;
    hiLoFunction!: boolean;
    bValveFunction!: boolean;
    maxPlungerFails!: number;
    criticalFlowRate!: number;
    afterflowOnFlowrateFunc!: boolean;

    init(_data?: any) {
        if (_data) {
            this.wellDepth = _data["wellDepth"];
            this.detectPlungerFalls = _data["detectPlungerFalls"];
            this.hiLoFunction = _data["hiLoFunction"];
            this.bValveFunction = _data["bValveFunction"];
            this.maxPlungerFails = _data["maxPlungerFails"];
            this.criticalFlowRate = _data["criticalFlowRate"];
            this.afterflowOnFlowrateFunc = _data["afterflowOnFlowrateFunc"];
        }
    }

    static fromJS(data: any): PlungerCommonWellSettingsApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlungerCommonWellSettingsApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellDepth"] = this.wellDepth;
        data["detectPlungerFalls"] = this.detectPlungerFalls;
        data["hiLoFunction"] = this.hiLoFunction;
        data["bValveFunction"] = this.bValveFunction;
        data["maxPlungerFails"] = this.maxPlungerFails;
        data["criticalFlowRate"] = this.criticalFlowRate;
        data["afterflowOnFlowrateFunc"] = this.afterflowOnFlowrateFunc;
        return data; 
    }
}

export class PlungerAutoAdjustModeSettingsApiModel {
    arrivalTimeMin!: number;
    arrivalTimeMax!: number;
    autoAdjLowerLimitAfterflow!: number;
    autoAdjLowerLimitShutIn!: number;
    autoAdjIncrementAfterFlow!: number;
    autoAdjIncrementShutIn!: number;
    autoAdjUpperLimitAfterflow!: number;
    autoAdjUpperLimitShutIn!: number;
    autoAdjPlungerType!: AutoAdjPlungerType;

    init(_data?: any) {
        if (_data) {
            this.arrivalTimeMin = _data["arrivalTimeMin"];
            this.arrivalTimeMax = _data["arrivalTimeMax"];
            this.autoAdjLowerLimitAfterflow = _data["autoAdjLowerLimitAfterflow"];
            this.autoAdjLowerLimitShutIn = _data["autoAdjLowerLimitShutIn"];
            this.autoAdjIncrementAfterFlow = _data["autoAdjIncrementAfterFlow"];
            this.autoAdjIncrementShutIn = _data["autoAdjIncrementShutIn"];
            this.autoAdjUpperLimitAfterflow = _data["autoAdjUpperLimitAfterflow"];
            this.autoAdjUpperLimitShutIn = _data["autoAdjUpperLimitShutIn"];
            this.autoAdjPlungerType = _data["autoAdjPlungerType"];
        }
    }

    static fromJS(data: any): PlungerAutoAdjustModeSettingsApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlungerAutoAdjustModeSettingsApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arrivalTimeMin"] = this.arrivalTimeMin;
        data["arrivalTimeMax"] = this.arrivalTimeMax;
        data["autoAdjLowerLimitAfterflow"] = this.autoAdjLowerLimitAfterflow;
        data["autoAdjLowerLimitShutIn"] = this.autoAdjLowerLimitShutIn;
        data["autoAdjIncrementAfterFlow"] = this.autoAdjIncrementAfterFlow;
        data["autoAdjIncrementShutIn"] = this.autoAdjIncrementShutIn;
        data["autoAdjUpperLimitAfterflow"] = this.autoAdjUpperLimitAfterflow;
        data["autoAdjUpperLimitShutIn"] = this.autoAdjUpperLimitShutIn;
        data["autoAdjPlungerType"] = this.autoAdjPlungerType;
        return data; 
    }
}

export enum AutoAdjPlungerType {
    BypassPlunger = 0,
    ConventionalPlunger = 1,
}

export class PlungerPressureModeSettingsApiModel {
    casingUpturnFunction!: boolean;
    casingHoldFunction!: boolean;
    casingHoldAfterflowThreshold!: number;
    casingHoldShutInThreshold!: number;
    casingUpturnValue!: number;
    loadFactorMinShutIn!: number;
    loadFactor!: number;
    loadFactorFunction!: boolean;
    pressureModeThreshold!: number;
    whichPressurePort!: WhichPressurePort;

    init(_data?: any) {
        if (_data) {
            this.casingUpturnFunction = _data["casingUpturnFunction"];
            this.casingHoldFunction = _data["casingHoldFunction"];
            this.casingHoldAfterflowThreshold = _data["casingHoldAfterflowThreshold"];
            this.casingHoldShutInThreshold = _data["casingHoldShutInThreshold"];
            this.casingUpturnValue = _data["casingUpturnValue"];
            this.loadFactorMinShutIn = _data["loadFactorMinShutIn"];
            this.loadFactor = _data["loadFactor"];
            this.loadFactorFunction = _data["loadFactorFunction"];
            this.pressureModeThreshold = _data["pressureModeThreshold"];
            this.whichPressurePort = _data["whichPressurePort"];
        }
    }

    static fromJS(data: any): PlungerPressureModeSettingsApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlungerPressureModeSettingsApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["casingUpturnFunction"] = this.casingUpturnFunction;
        data["casingHoldFunction"] = this.casingHoldFunction;
        data["casingHoldAfterflowThreshold"] = this.casingHoldAfterflowThreshold;
        data["casingHoldShutInThreshold"] = this.casingHoldShutInThreshold;
        data["casingUpturnValue"] = this.casingUpturnValue;
        data["loadFactorMinShutIn"] = this.loadFactorMinShutIn;
        data["loadFactor"] = this.loadFactor;
        data["loadFactorFunction"] = this.loadFactorFunction;
        data["pressureModeThreshold"] = this.pressureModeThreshold;
        data["whichPressurePort"] = this.whichPressurePort;
        return data; 
    }
}

export enum WhichPressurePort {
    UseCasingPressure = 0,
    UseTubingPressure = 1,
}

export class PlungerTimeModeSettingsApiModel {
    openTime!: number;
    afterflowTime!: number;
    shutinTime!: number;
    mandShutinTime!: number;
    afterflowMinTime!: number;
    afterflowMaxTime!: number;
    flowrateDelayTime!: number;

    init(_data?: any) {
        if (_data) {
            this.openTime = _data["openTime"];
            this.afterflowTime = _data["afterflowTime"];
            this.shutinTime = _data["shutinTime"];
            this.mandShutinTime = _data["mandShutinTime"];
            this.afterflowMinTime = _data["afterflowMinTime"];
            this.afterflowMaxTime = _data["afterflowMaxTime"];
            this.flowrateDelayTime = _data["flowrateDelayTime"];
        }
    }

    static fromJS(data: any): PlungerTimeModeSettingsApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlungerTimeModeSettingsApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openTime"] = this.openTime;
        data["afterflowTime"] = this.afterflowTime;
        data["shutinTime"] = this.shutinTime;
        data["mandShutinTime"] = this.mandShutinTime;
        data["afterflowMinTime"] = this.afterflowMinTime;
        data["afterflowMaxTime"] = this.afterflowMaxTime;
        data["flowrateDelayTime"] = this.flowrateDelayTime;
        return data; 
    }
}

export class PlungerJob {
    jobId?: string | undefined;
    status?: string | undefined;
    response?: any | undefined;
    request?: any | undefined;
    macaddr?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.status = _data["status"];
            this.response = _data["response"];
            this.request = _data["request"];
            this.macaddr = _data["macaddr"];
        }
    }

    static fromJS(data: any): PlungerJob {
        data = typeof data === 'object' ? data : {};
        let result = new PlungerJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["status"] = this.status;
        data["response"] = this.response;
        data["request"] = this.request;
        data["macaddr"] = this.macaddr;
        return data; 
    }
}

export class PlungerJobInfo {
    jobId?: string | undefined;
    status?: string | undefined;
    time!: number;

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.status = _data["status"];
            this.time = _data["time"];
        }
    }

    static fromJS(data: any): PlungerJobInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PlungerJobInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["status"] = this.status;
        data["time"] = this.time;
        return data; 
    }
}

export class UpdatePlungerOperatingModeRequest {
    operating_Mode!: PlungerOperatingMode;

    init(_data?: any) {
        if (_data) {
            this.operating_Mode = _data["Operating_Mode"];
        }
    }

    static fromJS(data: any): UpdatePlungerOperatingModeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlungerOperatingModeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Operating_Mode"] = this.operating_Mode;
        return data; 
    }
}

export abstract class AssetApiModelBase {
    id!: string;
    name?: string | undefined;
    operationalParameters?: OperationalParameters[] | undefined;
    telemetryTypeFormula?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["operationalParameters"])) {
                this.operationalParameters = [] as any;
                for (let item of _data["operationalParameters"])
                    this.operationalParameters!.push(OperationalParameters.fromJS(item));
            }
            this.telemetryTypeFormula = _data["telemetryTypeFormula"];
        }
    }

    static fromJS(data: any): AssetApiModelBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AssetApiModelBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.operationalParameters)) {
            data["operationalParameters"] = [];
            for (let item of this.operationalParameters)
                data["operationalParameters"].push(item.toJSON());
        }
        data["telemetryTypeFormula"] = this.telemetryTypeFormula;
        return data; 
    }
}

export class SitesSearchResponse extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SitesSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SitesSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class OperationalParameters {
    unitMeasure!: TelemetryUnitMeasure;
    ranges?: Ranges | undefined;

    init(_data?: any) {
        if (_data) {
            this.unitMeasure = _data["unitMeasure"];
            this.ranges = _data["ranges"] ? Ranges.fromJS(_data["ranges"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OperationalParameters {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitMeasure"] = this.unitMeasure;
        data["ranges"] = this.ranges ? this.ranges.toJSON() : <any>undefined;
        return data; 
    }
}

export enum TelemetryUnitMeasure {
    Inches = 1,
    BPH = 2,
    PSIG = 3,
    SPM = 4,
    GAL = 5,
    Bbls = 6,
    TemperaturePressure = 7,
    Vibration = 8,
}

export class Ranges {
    min!: number;
    max!: number;

    init(_data?: any) {
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }

    static fromJS(data: any): Ranges {
        data = typeof data === 'object' ? data : {};
        let result = new Ranges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        return data; 
    }
}

export class AssetsSearchResponse extends AssetApiModelBase {
    fullName?: string | undefined;
    siteId?: string | undefined;
    telemetryType!: TelemetryType;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullName = _data["fullName"];
            this.siteId = _data["siteId"];
            this.telemetryType = _data["telemetryType"];
        }
    }

    static fromJS(data: any): AssetsSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetsSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["siteId"] = this.siteId;
        data["telemetryType"] = this.telemetryType;
        super.toJSON(data);
        return data; 
    }
}

export enum TelemetryType {
    TubingPressure = 1,
    CasingPressure = 2,
    TankLevel = 3,
    DiffPressure = 5,
    StaticPressure = 6,
    StaticTemp = 7,
    Flow = 8,
    GatewayMetrics = 9,
    SensorBatteryLevel = 10,
    HeaterTemp = 11,
    CrankRevolutions = 12,
    SeparatorPressure = 13,
    CompressorPressure = 14,
    PumpPressure = 15,
    LiquidFlow = 16,
    GasFlow = 17,
    StrokesPerMinute = 18,
    TemperaturePressure = 19,
    Vibration = 20,
    KnockoutPressure = 21,
    BalancedTank = 22,
    FlareStatus = 23,
    PumpControl = 24,
    GenericSensor = 999,
}

export class ProductResponse {
    /** type id 1-water, 2-oil, 3-gas */
    id!: number;
    /** description type */
    type?: string | undefined;
    /** unit of values */
    unit?: string | undefined;
    /** summary value of the product */
    summary!: number;
    details?: ProductDetailResponse[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.unit = _data["unit"];
            this.summary = _data["summary"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ProductDetailResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["unit"] = this.unit;
        data["summary"] = this.summary;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export class ProductDetailResponse {
    /** Day in the range */
    date!: Date;
    /** lastest value of the product in the day */
    value!: number;

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProductDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data; 
    }
}

export class ProductTypeModel {
    id!: number;
    name?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProductTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export class PumpResponse {
    id?: string | undefined;
    siteId?: string | undefined;
    assetsId?: string[] | undefined;
    assetsName?: string[] | undefined;
    assetName?: string | undefined;
    pumpDeviceId?: string | undefined;
    enableNotifications!: boolean;
    frequency?: PumpFrequency | undefined;
    model?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            if (Array.isArray(_data["assetsId"])) {
                this.assetsId = [] as any;
                for (let item of _data["assetsId"])
                    this.assetsId!.push(item);
            }
            if (Array.isArray(_data["assetsName"])) {
                this.assetsName = [] as any;
                for (let item of _data["assetsName"])
                    this.assetsName!.push(item);
            }
            this.assetName = _data["assetName"];
            this.pumpDeviceId = _data["pumpDeviceId"];
            this.enableNotifications = _data["enableNotifications"];
            this.frequency = _data["frequency"] ? PumpFrequency.fromJS(_data["frequency"]) : <any>undefined;
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): PumpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PumpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        if (Array.isArray(this.assetsId)) {
            data["assetsId"] = [];
            for (let item of this.assetsId)
                data["assetsId"].push(item);
        }
        if (Array.isArray(this.assetsName)) {
            data["assetsName"] = [];
            for (let item of this.assetsName)
                data["assetsName"].push(item);
        }
        data["assetName"] = this.assetName;
        data["pumpDeviceId"] = this.pumpDeviceId;
        data["enableNotifications"] = this.enableNotifications;
        data["frequency"] = this.frequency ? this.frequency.toJSON() : <any>undefined;
        data["model"] = this.model;
        return data; 
    }
}

export class PumpFrequency {
    hasFrequency!: boolean;
    min!: number;
    max!: number;

    init(_data?: any) {
        if (_data) {
            this.hasFrequency = _data["hasFrequency"];
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }

    static fromJS(data: any): PumpFrequency {
        data = typeof data === 'object' ? data : {};
        let result = new PumpFrequency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasFrequency"] = this.hasFrequency;
        data["min"] = this.min;
        data["max"] = this.max;
        return data; 
    }
}

export class ProvisionPumpRequest {
    siteId!: string;
    assetsId!: string[];
    pumpDeviceId!: string;
    enableNotifications!: boolean;
    frequency!: PumpFrequency;
    model?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            if (Array.isArray(_data["assetsId"])) {
                this.assetsId = [] as any;
                for (let item of _data["assetsId"])
                    this.assetsId!.push(item);
            }
            this.pumpDeviceId = _data["pumpDeviceId"];
            this.enableNotifications = _data["enableNotifications"];
            this.frequency = _data["frequency"] ? PumpFrequency.fromJS(_data["frequency"]) : new PumpFrequency();
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): ProvisionPumpRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProvisionPumpRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        if (Array.isArray(this.assetsId)) {
            data["assetsId"] = [];
            for (let item of this.assetsId)
                data["assetsId"].push(item);
        }
        data["pumpDeviceId"] = this.pumpDeviceId;
        data["enableNotifications"] = this.enableNotifications;
        data["frequency"] = this.frequency ? this.frequency.toJSON() : <any>undefined;
        data["model"] = this.model;
        return data; 
    }
}

export class PumpTelemetryModel {
    siteId?: string | undefined;
    assetsId?: string[] | undefined;
    creationTimeUtc!: Date;
    status?: string | undefined;
    pumpDeviceId?: string | undefined;
    metadata?: PumpMetaData[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            if (Array.isArray(_data["assetsId"])) {
                this.assetsId = [] as any;
                for (let item of _data["assetsId"])
                    this.assetsId!.push(item);
            }
            this.creationTimeUtc = _data["creationTimeUtc"] ? new Date(_data["creationTimeUtc"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.pumpDeviceId = _data["pumpDeviceId"];
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(PumpMetaData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PumpTelemetryModel {
        data = typeof data === 'object' ? data : {};
        let result = new PumpTelemetryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        if (Array.isArray(this.assetsId)) {
            data["assetsId"] = [];
            for (let item of this.assetsId)
                data["assetsId"].push(item);
        }
        data["creationTimeUtc"] = this.creationTimeUtc ? this.creationTimeUtc.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["pumpDeviceId"] = this.pumpDeviceId;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item.toJSON());
        }
        return data; 
    }
}

export class PumpMetaData {
    key?: string | undefined;
    value!: number;
    uom?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.uom = _data["uom"];
        }
    }

    static fromJS(data: any): PumpMetaData {
        data = typeof data === 'object' ? data : {};
        let result = new PumpMetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["uom"] = this.uom;
        return data; 
    }
}

export class PumpLogRequest {
    siteId?: string | undefined;
    source!: PumpLogSource;
    assetsId?: string[] | undefined;
    email?: string | undefined;
    creationTimeUtc!: Date;
    pumpDeviceId?: string | undefined;
    oldStatus?: string | undefined;
    newStatus?: string | undefined;
    logType!: PumpLogType;

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.source = _data["source"];
            if (Array.isArray(_data["assetsId"])) {
                this.assetsId = [] as any;
                for (let item of _data["assetsId"])
                    this.assetsId!.push(item);
            }
            this.email = _data["email"];
            this.creationTimeUtc = _data["creationTimeUtc"] ? new Date(_data["creationTimeUtc"].toString()) : <any>undefined;
            this.pumpDeviceId = _data["pumpDeviceId"];
            this.oldStatus = _data["oldStatus"];
            this.newStatus = _data["newStatus"];
            this.logType = _data["logType"];
        }
    }

    static fromJS(data: any): PumpLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PumpLogRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["source"] = this.source;
        if (Array.isArray(this.assetsId)) {
            data["assetsId"] = [];
            for (let item of this.assetsId)
                data["assetsId"].push(item);
        }
        data["email"] = this.email;
        data["creationTimeUtc"] = this.creationTimeUtc ? this.creationTimeUtc.toISOString() : <any>undefined;
        data["pumpDeviceId"] = this.pumpDeviceId;
        data["oldStatus"] = this.oldStatus;
        data["newStatus"] = this.newStatus;
        data["logType"] = this.logType;
        return data; 
    }
}

export enum PumpLogSource {
    User = 0,
    Thresholds = 1,
    Manual = 2,
}

export enum PumpLogType {
    ChangeStatus = 0,
    ChangeFrequency = 1,
}

export class PumpLogServiceResponse {
    siteId?: string | undefined;
    source!: PumpLogSource;
    creationTimeUtc!: Date;
    pumpDeviceId?: string | undefined;
    oldStatus?: string | undefined;
    newStatus?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.source = _data["source"];
            this.creationTimeUtc = _data["creationTimeUtc"] ? new Date(_data["creationTimeUtc"].toString()) : <any>undefined;
            this.pumpDeviceId = _data["pumpDeviceId"];
            this.oldStatus = _data["oldStatus"];
            this.newStatus = _data["newStatus"];
        }
    }

    static fromJS(data: any): PumpLogServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PumpLogServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["source"] = this.source;
        data["creationTimeUtc"] = this.creationTimeUtc ? this.creationTimeUtc.toISOString() : <any>undefined;
        data["pumpDeviceId"] = this.pumpDeviceId;
        data["oldStatus"] = this.oldStatus;
        data["newStatus"] = this.newStatus;
        return data; 
    }
}

export class PagedResultOfPumpLogsWebResponse {
    result?: PumpLogsWebResponse[] | undefined;
    count!: number;
    pageCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(PumpLogsWebResponse.fromJS(item));
            }
            this.count = _data["count"];
            this.pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): PagedResultOfPumpLogsWebResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfPumpLogsWebResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["pageCount"] = this.pageCount;
        return data; 
    }
}

export class PumpLogsWebResponse {
    siteId?: string | undefined;
    siteName?: string | undefined;
    source?: string | undefined;
    email?: string | undefined;
    creationTimeUtc!: Date;
    pumpDeviceId?: string | undefined;
    oldStatus?: string | undefined;
    newStatus?: string | undefined;
    assetId?: string | undefined;
    assetName?: string | undefined;
    logType?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.source = _data["source"];
            this.email = _data["email"];
            this.creationTimeUtc = _data["creationTimeUtc"] ? new Date(_data["creationTimeUtc"].toString()) : <any>undefined;
            this.pumpDeviceId = _data["pumpDeviceId"];
            this.oldStatus = _data["oldStatus"];
            this.newStatus = _data["newStatus"];
            this.assetId = _data["assetId"];
            this.assetName = _data["assetName"];
            this.logType = _data["logType"];
        }
    }

    static fromJS(data: any): PumpLogsWebResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PumpLogsWebResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["source"] = this.source;
        data["email"] = this.email;
        data["creationTimeUtc"] = this.creationTimeUtc ? this.creationTimeUtc.toISOString() : <any>undefined;
        data["pumpDeviceId"] = this.pumpDeviceId;
        data["oldStatus"] = this.oldStatus;
        data["newStatus"] = this.newStatus;
        data["assetId"] = this.assetId;
        data["assetName"] = this.assetName;
        data["logType"] = this.logType;
        return data; 
    }
}

export class SensorWithBatteryResponse {
    sensorId?: string | undefined;
    siteId?: string | undefined;
    useCase!: SensorUseCase;
    sensorModel?: string | undefined;
    sensorModelDescription?: string | undefined;
    gatewayId?: string | undefined;
    assetId?: string | undefined;
    provisionDate?: Date | undefined;
    batteryLevel?: number | undefined;
    batteryLevelDate?: Date | undefined;

    init(_data?: any) {
        if (_data) {
            this.sensorId = _data["sensorId"];
            this.siteId = _data["siteId"];
            this.useCase = _data["useCase"];
            this.sensorModel = _data["sensorModel"];
            this.sensorModelDescription = _data["sensorModelDescription"];
            this.gatewayId = _data["gatewayId"];
            this.assetId = _data["assetId"];
            this.provisionDate = _data["provisionDate"] ? new Date(_data["provisionDate"].toString()) : <any>undefined;
            this.batteryLevel = _data["batteryLevel"];
            this.batteryLevelDate = _data["batteryLevelDate"] ? new Date(_data["batteryLevelDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SensorWithBatteryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SensorWithBatteryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sensorId"] = this.sensorId;
        data["siteId"] = this.siteId;
        data["useCase"] = this.useCase;
        data["sensorModel"] = this.sensorModel;
        data["sensorModelDescription"] = this.sensorModelDescription;
        data["gatewayId"] = this.gatewayId;
        data["assetId"] = this.assetId;
        data["provisionDate"] = this.provisionDate ? this.provisionDate.toISOString() : <any>undefined;
        data["batteryLevel"] = this.batteryLevel;
        data["batteryLevelDate"] = this.batteryLevelDate ? this.batteryLevelDate.toISOString() : <any>undefined;
        return data; 
    }
}

export enum SensorUseCase {
    Gateway = 0,
    Tank = 1,
    Casing = 2,
    Tubing = 3,
    Static = 4,
    Differential = 5,
    Heater = 6,
    Revolutions = 7,
    Separator = 8,
    Compressor = 9,
    Pump = 10,
    Turbine = 11,
    TotalFlow = 12,
    SPM = 13,
    TemperaturePressure = 14,
    Vibration = 15,
    KnockoutPressure = 16,
    BalancedTank = 17,
    FlareStatus = 18,
    PumpControl = 19,
}

export class PagedResultOfSensorResponse {
    result?: SensorResponse[] | undefined;
    count!: number;
    pageCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(SensorResponse.fromJS(item));
            }
            this.count = _data["count"];
            this.pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): PagedResultOfSensorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfSensorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["pageCount"] = this.pageCount;
        return data; 
    }
}

export class SensorResponse {
    id?: string | undefined;
    siteId?: string | undefined;
    modelName?: string | undefined;
    createdAt!: Date;
    updatedAt!: Date;
    channels?: SensorChannelApiModel[] | undefined;
    useCase!: SensorUseCase;
    gatewayId?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            this.modelName = _data["modelName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(SensorChannelApiModel.fromJS(item));
            }
            this.useCase = _data["useCase"];
            this.gatewayId = _data["gatewayId"];
        }
    }

    static fromJS(data: any): SensorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SensorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        data["modelName"] = this.modelName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item.toJSON());
        }
        data["useCase"] = this.useCase;
        data["gatewayId"] = this.gatewayId;
        return data; 
    }
}

export class SensorChannelApiModel {
    id!: string;
    assetId!: string;
    telemetryType!: TelemetryType;
    transducerId!: number;
    attributes?: SensorChannelAttributeApiModel[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetId = _data["assetId"];
            this.telemetryType = _data["telemetryType"];
            this.transducerId = _data["transducerId"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(SensorChannelAttributeApiModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SensorChannelApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensorChannelApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetId"] = this.assetId;
        data["telemetryType"] = this.telemetryType;
        data["transducerId"] = this.transducerId;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        return data; 
    }
}

export class SensorChannelAttributeApiModel {
    key!: string;
    value!: number;
    isLevelcon!: boolean;
    isMachfu!: boolean;
    isAcme!: boolean;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.isLevelcon = _data["isLevelcon"];
            this.isMachfu = _data["isMachfu"];
            this.isAcme = _data["isAcme"];
        }
    }

    static fromJS(data: any): SensorChannelAttributeApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensorChannelAttributeApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["isLevelcon"] = this.isLevelcon;
        data["isMachfu"] = this.isMachfu;
        data["isAcme"] = this.isAcme;
        return data; 
    }
}

export class WriteSensorApiModel {
    id!: string;
    siteId!: string;
    sensorModel!: string;
    gatewayId?: string | undefined;
    useCase!: SensorUseCase;
    channels!: SensorChannelApiModel[];

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            this.sensorModel = _data["sensorModel"];
            this.gatewayId = _data["gatewayId"];
            this.useCase = _data["useCase"];
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(SensorChannelApiModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WriteSensorApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new WriteSensorApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        data["sensorModel"] = this.sensorModel;
        data["gatewayId"] = this.gatewayId;
        data["useCase"] = this.useCase;
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item.toJSON());
        }
        return data; 
    }
}

export class SensorModelApiModel {
    id!: number;
    model?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): SensorModelApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensorModelApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["model"] = this.model;
        return data; 
    }
}

export class SensorUseCasesResponse {
    id!: number;
    description?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SensorUseCasesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SensorUseCasesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data; 
    }
}

export class SiteApiModel {
    id!: string;
    name!: string;
    active!: boolean;
    lon!: number;
    lat!: number;
    startDate?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    gasFlows?: GasFlowApiModel[] | undefined;
    location?: LocationApiModel | undefined;
    tanks?: TankApiModel[] | undefined;
    plungerLift?: PlungerLiftApiModel | undefined;
    heaters?: HeaterApiModel[] | undefined;
    separators?: SeparatorApiModel[] | undefined;
    compressors?: CompressorApiModel[] | undefined;
    liquidFlows?: LiquidFlowApiModel[] | undefined;
    staticPressure?: StaticPressureApiModel[] | undefined;
    strokesPerMinute?: StrokesPerMinuteApiModel[] | undefined;
    compressorDevice?: CompressorDeviceApiModel | undefined;
    vibrations?: VibrationApiModel[] | undefined;
    knockoutPressures?: KnockoutPressureApiModel[] | undefined;
    genericSensors?: GenericSensorApiModel[] | undefined;
    balancedTanks?: BalancedTankApiModel[] | undefined;
    flareStatus?: FlareStatusApiModel[] | undefined;
    pumpControls?: PumpControlApiModel[] | undefined;
    crankRevolutions?: CrankRevolutionsApiModel[] | undefined;
    tubingPressures?: TubingPressureApiModel[] | undefined;
    casingPressures?: CasingPressureApiModel[] | undefined;
    comment?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.active = _data["active"];
            this.lon = _data["lon"];
            this.lat = _data["lat"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["gasFlows"])) {
                this.gasFlows = [] as any;
                for (let item of _data["gasFlows"])
                    this.gasFlows!.push(GasFlowApiModel.fromJS(item));
            }
            this.location = _data["location"] ? LocationApiModel.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["tanks"])) {
                this.tanks = [] as any;
                for (let item of _data["tanks"])
                    this.tanks!.push(TankApiModel.fromJS(item));
            }
            this.plungerLift = _data["plungerLift"] ? PlungerLiftApiModel.fromJS(_data["plungerLift"]) : <any>undefined;
            if (Array.isArray(_data["heaters"])) {
                this.heaters = [] as any;
                for (let item of _data["heaters"])
                    this.heaters!.push(HeaterApiModel.fromJS(item));
            }
            if (Array.isArray(_data["separators"])) {
                this.separators = [] as any;
                for (let item of _data["separators"])
                    this.separators!.push(SeparatorApiModel.fromJS(item));
            }
            if (Array.isArray(_data["compressors"])) {
                this.compressors = [] as any;
                for (let item of _data["compressors"])
                    this.compressors!.push(CompressorApiModel.fromJS(item));
            }
            if (Array.isArray(_data["liquidFlows"])) {
                this.liquidFlows = [] as any;
                for (let item of _data["liquidFlows"])
                    this.liquidFlows!.push(LiquidFlowApiModel.fromJS(item));
            }
            if (Array.isArray(_data["staticPressure"])) {
                this.staticPressure = [] as any;
                for (let item of _data["staticPressure"])
                    this.staticPressure!.push(StaticPressureApiModel.fromJS(item));
            }
            if (Array.isArray(_data["strokesPerMinute"])) {
                this.strokesPerMinute = [] as any;
                for (let item of _data["strokesPerMinute"])
                    this.strokesPerMinute!.push(StrokesPerMinuteApiModel.fromJS(item));
            }
            this.compressorDevice = _data["compressorDevice"] ? CompressorDeviceApiModel.fromJS(_data["compressorDevice"]) : <any>undefined;
            if (Array.isArray(_data["vibrations"])) {
                this.vibrations = [] as any;
                for (let item of _data["vibrations"])
                    this.vibrations!.push(VibrationApiModel.fromJS(item));
            }
            if (Array.isArray(_data["knockoutPressures"])) {
                this.knockoutPressures = [] as any;
                for (let item of _data["knockoutPressures"])
                    this.knockoutPressures!.push(KnockoutPressureApiModel.fromJS(item));
            }
            if (Array.isArray(_data["genericSensors"])) {
                this.genericSensors = [] as any;
                for (let item of _data["genericSensors"])
                    this.genericSensors!.push(GenericSensorApiModel.fromJS(item));
            }
            if (Array.isArray(_data["balancedTanks"])) {
                this.balancedTanks = [] as any;
                for (let item of _data["balancedTanks"])
                    this.balancedTanks!.push(BalancedTankApiModel.fromJS(item));
            }
            if (Array.isArray(_data["flareStatus"])) {
                this.flareStatus = [] as any;
                for (let item of _data["flareStatus"])
                    this.flareStatus!.push(FlareStatusApiModel.fromJS(item));
            }
            if (Array.isArray(_data["pumpControls"])) {
                this.pumpControls = [] as any;
                for (let item of _data["pumpControls"])
                    this.pumpControls!.push(PumpControlApiModel.fromJS(item));
            }
            if (Array.isArray(_data["crankRevolutions"])) {
                this.crankRevolutions = [] as any;
                for (let item of _data["crankRevolutions"])
                    this.crankRevolutions!.push(CrankRevolutionsApiModel.fromJS(item));
            }
            if (Array.isArray(_data["tubingPressures"])) {
                this.tubingPressures = [] as any;
                for (let item of _data["tubingPressures"])
                    this.tubingPressures!.push(TubingPressureApiModel.fromJS(item));
            }
            if (Array.isArray(_data["casingPressures"])) {
                this.casingPressures = [] as any;
                for (let item of _data["casingPressures"])
                    this.casingPressures!.push(CasingPressureApiModel.fromJS(item));
            }
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): SiteApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new SiteApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["active"] = this.active;
        data["lon"] = this.lon;
        data["lat"] = this.lat;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.gasFlows)) {
            data["gasFlows"] = [];
            for (let item of this.gasFlows)
                data["gasFlows"].push(item.toJSON());
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.tanks)) {
            data["tanks"] = [];
            for (let item of this.tanks)
                data["tanks"].push(item.toJSON());
        }
        data["plungerLift"] = this.plungerLift ? this.plungerLift.toJSON() : <any>undefined;
        if (Array.isArray(this.heaters)) {
            data["heaters"] = [];
            for (let item of this.heaters)
                data["heaters"].push(item.toJSON());
        }
        if (Array.isArray(this.separators)) {
            data["separators"] = [];
            for (let item of this.separators)
                data["separators"].push(item.toJSON());
        }
        if (Array.isArray(this.compressors)) {
            data["compressors"] = [];
            for (let item of this.compressors)
                data["compressors"].push(item.toJSON());
        }
        if (Array.isArray(this.liquidFlows)) {
            data["liquidFlows"] = [];
            for (let item of this.liquidFlows)
                data["liquidFlows"].push(item.toJSON());
        }
        if (Array.isArray(this.staticPressure)) {
            data["staticPressure"] = [];
            for (let item of this.staticPressure)
                data["staticPressure"].push(item.toJSON());
        }
        if (Array.isArray(this.strokesPerMinute)) {
            data["strokesPerMinute"] = [];
            for (let item of this.strokesPerMinute)
                data["strokesPerMinute"].push(item.toJSON());
        }
        data["compressorDevice"] = this.compressorDevice ? this.compressorDevice.toJSON() : <any>undefined;
        if (Array.isArray(this.vibrations)) {
            data["vibrations"] = [];
            for (let item of this.vibrations)
                data["vibrations"].push(item.toJSON());
        }
        if (Array.isArray(this.knockoutPressures)) {
            data["knockoutPressures"] = [];
            for (let item of this.knockoutPressures)
                data["knockoutPressures"].push(item.toJSON());
        }
        if (Array.isArray(this.genericSensors)) {
            data["genericSensors"] = [];
            for (let item of this.genericSensors)
                data["genericSensors"].push(item.toJSON());
        }
        if (Array.isArray(this.balancedTanks)) {
            data["balancedTanks"] = [];
            for (let item of this.balancedTanks)
                data["balancedTanks"].push(item.toJSON());
        }
        if (Array.isArray(this.flareStatus)) {
            data["flareStatus"] = [];
            for (let item of this.flareStatus)
                data["flareStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.pumpControls)) {
            data["pumpControls"] = [];
            for (let item of this.pumpControls)
                data["pumpControls"].push(item.toJSON());
        }
        if (Array.isArray(this.crankRevolutions)) {
            data["crankRevolutions"] = [];
            for (let item of this.crankRevolutions)
                data["crankRevolutions"].push(item.toJSON());
        }
        if (Array.isArray(this.tubingPressures)) {
            data["tubingPressures"] = [];
            for (let item of this.tubingPressures)
                data["tubingPressures"].push(item.toJSON());
        }
        if (Array.isArray(this.casingPressures)) {
            data["casingPressures"] = [];
            for (let item of this.casingPressures)
                data["casingPressures"].push(item.toJSON());
        }
        data["comment"] = this.comment;
        return data; 
    }
}

export class GasFlowApiModel extends AssetApiModelBase {
    totalFlowType?: string | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalFlowType = _data["totalFlowType"];
        }
    }

    static fromJS(data: any): GasFlowApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new GasFlowApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalFlowType"] = this.totalFlowType;
        super.toJSON(data);
        return data; 
    }
}

export class LocationApiModel {
    state?: string | undefined;
    county?: string | undefined;
    township?: string | undefined;
    region?: string | undefined;
    field?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.county = _data["county"];
            this.township = _data["township"];
            this.region = _data["region"];
            this.field = _data["field"];
        }
    }

    static fromJS(data: any): LocationApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["county"] = this.county;
        data["township"] = this.township;
        data["region"] = this.region;
        data["field"] = this.field;
        return data; 
    }
}

export class TankApiModel extends AssetApiModelBase {
    capacity!: number;
    height!: number;
    gravity!: number;
    productionCode!: ProductionCode;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.capacity = _data["capacity"];
            this.height = _data["height"];
            this.gravity = _data["gravity"];
            this.productionCode = _data["productionCode"];
        }
    }

    static fromJS(data: any): TankApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new TankApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["capacity"] = this.capacity;
        data["height"] = this.height;
        data["gravity"] = this.gravity;
        data["productionCode"] = this.productionCode;
        super.toJSON(data);
        return data; 
    }
}

export enum ProductionCode {
    Undefined = 0,
    Oil = 1,
    Water = 2,
    Chemical = 3,
}

export class PlungerLiftApiModel extends AssetApiModelBase {
    type!: PlungerLiftType;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PlungerLiftApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlungerLiftApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        super.toJSON(data);
        return data; 
    }
}

export enum PlungerLiftType {
    Unknown = 0,
    Epic = 1,
}

export class HeaterApiModel extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): HeaterApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new HeaterApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class SeparatorApiModel extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SeparatorApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new SeparatorApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class CompressorApiModel extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CompressorApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompressorApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class LiquidFlowApiModel extends AssetApiModelBase {
    kfactor!: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.kfactor = _data["kfactor"];
        }
    }

    static fromJS(data: any): LiquidFlowApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new LiquidFlowApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kfactor"] = this.kfactor;
        super.toJSON(data);
        return data; 
    }
}

export class StaticPressureApiModel extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): StaticPressureApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPressureApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class StrokesPerMinuteApiModel extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): StrokesPerMinuteApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new StrokesPerMinuteApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class CompressorDeviceApiModel extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CompressorDeviceApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompressorDeviceApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class VibrationApiModel extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): VibrationApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new VibrationApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class KnockoutPressureApiModel extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): KnockoutPressureApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new KnockoutPressureApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class GenericSensorApiModel extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GenericSensorApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericSensorApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class BalancedTankApiModel extends TankApiModel {
    numberOfTanks!: number;
    totalCapacity!: number;
    balancedHeight!: number;
    isReciver!: boolean;
    isInactive!: boolean;
    tanks?: BalancedPerTank[] | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.numberOfTanks = _data["numberOfTanks"];
            this.totalCapacity = _data["totalCapacity"];
            this.balancedHeight = _data["balancedHeight"];
            this.isReciver = _data["isReciver"];
            this.isInactive = _data["isInactive"];
            if (Array.isArray(_data["tanks"])) {
                this.tanks = [] as any;
                for (let item of _data["tanks"])
                    this.tanks!.push(BalancedPerTank.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BalancedTankApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new BalancedTankApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfTanks"] = this.numberOfTanks;
        data["totalCapacity"] = this.totalCapacity;
        data["balancedHeight"] = this.balancedHeight;
        data["isReciver"] = this.isReciver;
        data["isInactive"] = this.isInactive;
        if (Array.isArray(this.tanks)) {
            data["tanks"] = [];
            for (let item of this.tanks)
                data["tanks"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export abstract class AssetBase {
    id?: string | undefined;
    name?: string | undefined;
    operationalParameters?: OperationalParameters[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["operationalParameters"])) {
                this.operationalParameters = [] as any;
                for (let item of _data["operationalParameters"])
                    this.operationalParameters!.push(OperationalParameters.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AssetBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.operationalParameters)) {
            data["operationalParameters"] = [];
            for (let item of this.operationalParameters)
                data["operationalParameters"].push(item.toJSON());
        }
        return data; 
    }
}

export class Tank extends AssetBase {
    capacity!: number;
    height!: number;
    gravity!: number;
    productionCode!: ProductionCode;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.capacity = _data["capacity"];
            this.height = _data["height"];
            this.gravity = _data["gravity"];
            this.productionCode = _data["productionCode"];
        }
    }

    static fromJS(data: any): Tank {
        data = typeof data === 'object' ? data : {};
        let result = new Tank();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["capacity"] = this.capacity;
        data["height"] = this.height;
        data["gravity"] = this.gravity;
        data["productionCode"] = this.productionCode;
        super.toJSON(data);
        return data; 
    }
}

export class BalancedPerTank extends Tank {
    isInactive!: boolean;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isInactive = _data["isInactive"];
        }
    }

    static fromJS(data: any): BalancedPerTank {
        data = typeof data === 'object' ? data : {};
        let result = new BalancedPerTank();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInactive"] = this.isInactive;
        super.toJSON(data);
        return data; 
    }
}

export class FlareStatusApiModel extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): FlareStatusApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new FlareStatusApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class PumpControlApiModel extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PumpControlApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new PumpControlApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class CrankRevolutionsApiModel extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CrankRevolutionsApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new CrankRevolutionsApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class TubingPressureApiModel extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TubingPressureApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new TubingPressureApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class CasingPressureApiModel extends AssetApiModelBase {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CasingPressureApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new CasingPressureApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class DrillDownCluster {
    count!: number;
    latMin!: number;
    lonMin!: number;
    latMax!: number;
    lonMax!: number;

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.latMin = _data["latMin"];
            this.lonMin = _data["lonMin"];
            this.latMax = _data["latMax"];
            this.lonMax = _data["lonMax"];
        }
    }

    static fromJS(data: any): DrillDownCluster {
        data = typeof data === 'object' ? data : {};
        let result = new DrillDownCluster();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["latMin"] = this.latMin;
        data["lonMin"] = this.lonMin;
        data["latMax"] = this.latMax;
        data["lonMax"] = this.lonMax;
        return data; 
    }
}

export class EntityIdViewModel {
    id?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EntityIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export class AddSitesResponse {
    errors?: AddSiteError[] | undefined;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(AddSiteError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddSitesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddSitesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data; 
    }
}

export class AddSiteError {
    id?: string | undefined;
    code!: number;
    reason?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): AddSiteError {
        data = typeof data === 'object' ? data : {};
        let result = new AddSiteError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["reason"] = this.reason;
        return data; 
    }
}

export class SiteOwnerApiModel {
    siteId?: string | undefined;
    superintendent?: string | undefined;
    foreman?: string | undefined;
    pumper?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.superintendent = _data["superintendent"];
            this.foreman = _data["foreman"];
            this.pumper = _data["pumper"];
        }
    }

    static fromJS(data: any): SiteOwnerApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new SiteOwnerApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["superintendent"] = this.superintendent;
        data["foreman"] = this.foreman;
        data["pumper"] = this.pumper;
        return data; 
    }
}

export class SiteCommentRequestModel {
    comment?: string | undefined;
    siteId?: string | undefined;
    userEmail?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.siteId = _data["siteId"];
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): SiteCommentRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SiteCommentRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["siteId"] = this.siteId;
        data["userEmail"] = this.userEmail;
        return data; 
    }
}

export class SiteCommentResponseModel {
    id?: string | undefined;
    comment?: string | undefined;
    createdAt!: Date;
    updatedAt!: Date;
    siteId?: string | undefined;
    userEmail?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.siteId = _data["siteId"];
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): SiteCommentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SiteCommentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["siteId"] = this.siteId;
        data["userEmail"] = this.userEmail;
        return data; 
    }
}

export class GetTelemetryAveragesResponse {
    averages?: TelemetryAverageResponse[] | undefined;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["averages"])) {
                this.averages = [] as any;
                for (let item of _data["averages"])
                    this.averages!.push(TelemetryAverageResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTelemetryAveragesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTelemetryAveragesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.averages)) {
            data["averages"] = [];
            for (let item of this.averages)
                data["averages"].push(item.toJSON());
        }
        return data; 
    }
}

export class TelemetryAverageResponse {
    fromUtc!: Date;
    toUtc!: Date;
    value!: number;

    init(_data?: any) {
        if (_data) {
            this.fromUtc = _data["fromUtc"] ? new Date(_data["fromUtc"].toString()) : <any>undefined;
            this.toUtc = _data["toUtc"] ? new Date(_data["toUtc"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TelemetryAverageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryAverageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromUtc"] = this.fromUtc ? this.fromUtc.toISOString() : <any>undefined;
        data["toUtc"] = this.toUtc ? this.toUtc.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data; 
    }
}

export class AverageProcessDtoRequest {
    dateFrom!: Date;
    dateTo!: Date;
    timeZone?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): AverageProcessDtoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AverageProcessDtoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        return data; 
    }
}

export abstract class BaseGenericTableEntity {
    partitionKey?: string | undefined;
    rowKey?: string | undefined;
    timestamp!: Date;
    eTag?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.partitionKey = _data["partitionKey"];
            this.rowKey = _data["rowKey"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.eTag = _data["eTag"];
        }
    }

    static fromJS(data: any): BaseGenericTableEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseGenericTableEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partitionKey"] = this.partitionKey;
        data["rowKey"] = this.rowKey;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["eTag"] = this.eTag;
        return data; 
    }
}

export class TelemetryPeriodResponse extends BaseGenericTableEntity {
    bpdHourFrom?: string | undefined;
    bpdHourTo?: string | undefined;
    bpdExecutionHour?: string | undefined;
    tenantId!: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.bpdHourFrom = _data["bpdHourFrom"];
            this.bpdHourTo = _data["bpdHourTo"];
            this.bpdExecutionHour = _data["bpdExecutionHour"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): TelemetryPeriodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryPeriodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bpdHourFrom"] = this.bpdHourFrom;
        data["bpdHourTo"] = this.bpdHourTo;
        data["bpdExecutionHour"] = this.bpdExecutionHour;
        data["tenantId"] = this.tenantId;
        super.toJSON(data);
        return data; 
    }
}

export class TelemetryMessageViewModel {
    id?: string | undefined;
    assetId?: string | undefined;
    siteId?: string | undefined;
    telemetryType!: TelemetryType;
    creationTimeUtc!: Date;
    payload?: any | undefined;
    gatewayId?: string | undefined;
    isSimulated!: boolean;
    sensorBatteryLevel?: number | undefined;
    invalidData!: boolean;
    alerts?: TelemetryAlertViewModel[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetId = _data["assetId"];
            this.siteId = _data["siteId"];
            this.telemetryType = _data["telemetryType"];
            this.creationTimeUtc = _data["creationTimeUtc"] ? new Date(_data["creationTimeUtc"].toString()) : <any>undefined;
            this.payload = _data["payload"];
            this.gatewayId = _data["gatewayId"];
            this.isSimulated = _data["isSimulated"];
            this.sensorBatteryLevel = _data["sensorBatteryLevel"];
            this.invalidData = _data["invalidData"];
            if (Array.isArray(_data["alerts"])) {
                this.alerts = [] as any;
                for (let item of _data["alerts"])
                    this.alerts!.push(TelemetryAlertViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TelemetryMessageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryMessageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetId"] = this.assetId;
        data["siteId"] = this.siteId;
        data["telemetryType"] = this.telemetryType;
        data["creationTimeUtc"] = this.creationTimeUtc ? this.creationTimeUtc.toISOString() : <any>undefined;
        data["payload"] = this.payload;
        data["gatewayId"] = this.gatewayId;
        data["isSimulated"] = this.isSimulated;
        data["sensorBatteryLevel"] = this.sensorBatteryLevel;
        data["invalidData"] = this.invalidData;
        if (Array.isArray(this.alerts)) {
            data["alerts"] = [];
            for (let item of this.alerts)
                data["alerts"].push(item.toJSON());
        }
        return data; 
    }
}

export class TelemetryAlertViewModel {
    alertId?: string | undefined;
    userEmail?: string | undefined;
    timestamp?: Date | undefined;
    note?: string | undefined;
    thresholdsType!: ThresholdsType;

    init(_data?: any) {
        if (_data) {
            this.alertId = _data["alertId"];
            this.userEmail = _data["userEmail"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.thresholdsType = _data["thresholdsType"];
        }
    }

    static fromJS(data: any): TelemetryAlertViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryAlertViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertId"] = this.alertId;
        data["userEmail"] = this.userEmail;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["thresholdsType"] = this.thresholdsType;
        return data; 
    }
}

export enum ThresholdsType {
    Telemetry = 0,
    RateOfChange = 1,
}

export class TankLevelBalanceResponse {
    balance?: number | undefined;
    siteId?: string | undefined;
    assetId?: string | undefined;
    latestTelemetryDateTime?: Date | undefined;
    previousTelemetryDateTime?: Date | undefined;

    init(_data?: any) {
        if (_data) {
            this.balance = _data["balance"];
            this.siteId = _data["siteId"];
            this.assetId = _data["assetId"];
            this.latestTelemetryDateTime = _data["latestTelemetryDateTime"] ? new Date(_data["latestTelemetryDateTime"].toString()) : <any>undefined;
            this.previousTelemetryDateTime = _data["previousTelemetryDateTime"] ? new Date(_data["previousTelemetryDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TankLevelBalanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TankLevelBalanceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance;
        data["siteId"] = this.siteId;
        data["assetId"] = this.assetId;
        data["latestTelemetryDateTime"] = this.latestTelemetryDateTime ? this.latestTelemetryDateTime.toISOString() : <any>undefined;
        data["previousTelemetryDateTime"] = this.previousTelemetryDateTime ? this.previousTelemetryDateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export class TelemetryTypeResponse {
    id!: number;
    description?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TelemetryTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data; 
    }
}

export class ProvisionSensorRequest {
    siteId!: string;
    sensorId!: string;
    sensorModel!: string;
    useCase!: SensorUseCase;
    channels!: ProvisionChannelRequestModel[];

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.sensorId = _data["sensorId"];
            this.sensorModel = _data["sensorModel"];
            this.useCase = _data["useCase"];
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(ProvisionChannelRequestModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProvisionSensorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProvisionSensorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["sensorId"] = this.sensorId;
        data["sensorModel"] = this.sensorModel;
        data["useCase"] = this.useCase;
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item.toJSON());
        }
        return data; 
    }
}

export class ProvisionChannelRequestModel {
    id!: string;
    assetType!: string;
    transducerId!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetType = _data["assetType"];
            this.transducerId = _data["transducerId"];
        }
    }

    static fromJS(data: any): ProvisionChannelRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProvisionChannelRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetType"] = this.assetType;
        data["transducerId"] = this.transducerId;
        return data; 
    }
}

export class ProvisionSensorRequestV3 {
    sensorId!: string;
    siteId?: string | undefined;
    sensorModel!: string;
    gatewayId!: string;
    useCase!: SensorUseCase;
    channels!: ProvisionChannelRequestModelV3[];

    init(_data?: any) {
        if (_data) {
            this.sensorId = _data["sensorId"];
            this.siteId = _data["siteId"];
            this.sensorModel = _data["sensorModel"];
            this.gatewayId = _data["gatewayId"];
            this.useCase = _data["useCase"];
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(ProvisionChannelRequestModelV3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProvisionSensorRequestV3 {
        data = typeof data === 'object' ? data : {};
        let result = new ProvisionSensorRequestV3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sensorId"] = this.sensorId;
        data["siteId"] = this.siteId;
        data["sensorModel"] = this.sensorModel;
        data["gatewayId"] = this.gatewayId;
        data["useCase"] = this.useCase;
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item.toJSON());
        }
        return data; 
    }
}

export class ProvisionChannelRequestModelV3 {
    id!: string;
    assetId!: string;
    telemetryType!: TelemetryType;
    transducerId!: number;
    attributes?: ProvisionChannelAttributeRequestModelV3[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetId = _data["assetId"];
            this.telemetryType = _data["telemetryType"];
            this.transducerId = _data["transducerId"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(ProvisionChannelAttributeRequestModelV3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProvisionChannelRequestModelV3 {
        data = typeof data === 'object' ? data : {};
        let result = new ProvisionChannelRequestModelV3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetId"] = this.assetId;
        data["telemetryType"] = this.telemetryType;
        data["transducerId"] = this.transducerId;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        return data; 
    }
}

export class ProvisionChannelAttributeRequestModelV3 {
    key?: string | undefined;
    value!: number;
    isLevelcon!: boolean;
    isMachfu!: boolean;
    isAcme!: boolean;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.isLevelcon = _data["isLevelcon"];
            this.isMachfu = _data["isMachfu"];
            this.isAcme = _data["isAcme"];
        }
    }

    static fromJS(data: any): ProvisionChannelAttributeRequestModelV3 {
        data = typeof data === 'object' ? data : {};
        let result = new ProvisionChannelAttributeRequestModelV3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["isLevelcon"] = this.isLevelcon;
        data["isMachfu"] = this.isMachfu;
        data["isAcme"] = this.isAcme;
        return data; 
    }
}

export class ProvisionGatewayRequest {
    gatewayId!: string;
    siteId?: string | undefined;
    enableAlerts!: boolean;
    sensorModel!: string;

    init(_data?: any) {
        if (_data) {
            this.gatewayId = _data["gatewayId"];
            this.siteId = _data["siteId"];
            this.enableAlerts = _data["enableAlerts"];
            this.sensorModel = _data["sensorModel"];
        }
    }

    static fromJS(data: any): ProvisionGatewayRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProvisionGatewayRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayId"] = this.gatewayId;
        data["siteId"] = this.siteId;
        data["enableAlerts"] = this.enableAlerts;
        data["sensorModel"] = this.sensorModel;
        return data; 
    }
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}